import { render, staticRenderFns } from "./StudyPeriodSelect.vue?vue&type=template&id=3be88f8e&scoped=true&"
import script from "./StudyPeriodSelect.vue?vue&type=script&lang=js&"
export * from "./StudyPeriodSelect.vue?vue&type=script&lang=js&"
import style0 from "./StudyPeriodSelect.vue?vue&type=style&index=0&id=3be88f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be88f8e",
  null
  
)

export default component.exports